// extracted by mini-css-extract-plugin
export default {"all":"VerifyEmail_all__S1oH6","content":"VerifyEmail_content__klt+s","logo":"VerifyEmail_logo__-fgYS"};